/**
 * Скрипт обрезки текста, который выходит за пределы карточки поста
 *
 * Для корректной работы, в шаблоне надо указать основной контейнер, элемент, где текст для обрезки и элементы, которые
 * не обрезаются, но занимают место (например, иконки)
 */

const clamp = () => {
    const clampContainer = 'js-clamp2__container';
    const clampText = 'js-clamp2__text';
    const fillingElement = 'js-clamp2__fill-element'; // Элементы, которые занимают место внизу, внутри контейнера

    // Проверяем, выходит ли текст за пределы контейнера
    $('.' + clampContainer).each((index, element) => {
        const textElement = $(element).find('.' + clampText);

        // учитываем то, что нижний padding надо вычесть
        let bottomLineContainer = $(element).offset().top + $(element).outerHeight() - parseInt($(element).css('padding-bottom')) ;
        const bottomLineText = textElement.offset().top + textElement.height();

        // Учитываем нижние элементы, если они есть
        const $fillingElements = $(element).find('.' + fillingElement);

        if ($fillingElements.length) {
            bottomLineContainer = bottomLineContainer - sumFillingElements($fillingElements);
        }

        // делаем обрезку текста, если текст выходит за контейнер
        if (bottomLineText > bottomLineContainer) {
            const freeHeight = textElement.outerHeight() - (bottomLineText - bottomLineContainer);
            const lineLimit = Math.floor(freeHeight / parseInt(textElement.css('lineHeight')));

            textElement.css({
                'display': '-webkit-box',
                '-webkit-box-orient': 'vertical',
                'overflow': 'hidden',
            });

            textElement.css('-webkit-line-clamp', lineLimit.toString());
        }
    });
}

$(document).on('ready hh:archive:page_load hh:archive:layout_switched hh:home-page:need-help', () => {
    clamp();
});

$(window).on('load', function () {
    clamp();
});

const sumFillingElements = ($fillingElements) => {
    let height = 0;

    $fillingElements.each((index, element) => {
        height += $(element).outerHeight(true);
    })

    return height;
}

export default clamp;